var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 mb-2"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header",on:{"click":function($event){_vm.fetchData()}}},[_vm._v(_vm._s(_vm.home.label))]),_vm._v(" "),_c('div',{staticClass:"card-body p-0"},[_c('div',{staticClass:"j-dashboard",attrs:{"id":_vm.id}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c9cdb02","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cards/HistogramCard.vue
// module id = null
// module chunks = 